import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import BranchForm from './BranchForm'
import { Branch, CreateBranchInput, UpdateBranchInput } from '@/queries/useBranches'
import { useTranslation } from 'react-i18next'

interface BranchDialogProps {
  branch: Branch | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onSubmit: (data: CreateBranchInput | UpdateBranchInput) => void | Promise<void>
  isLoading?: boolean
  error?: Error | null
}

export default function BranchDialog({
  branch,
  open,
  onOpenChange,
  onSubmit,
  isLoading = false,
  error,
}: BranchDialogProps) {
  const { t } = useTranslation('admin')
  const isEditMode = !!branch

  const handleSubmit = async (data: CreateBranchInput | UpdateBranchInput) => {
    await onSubmit(data)
    onOpenChange(false)
  }

  const handleCancel = () => {
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[500px]"
        data-testid={isEditMode ? 'edit-branch-dialog' : 'create-branch-dialog'}
      >
        <DialogHeader>
          <DialogTitle data-testid="branch-dialog-title">
            {isEditMode ? t('branches.dialog.editTitle') : t('branches.dialog.createTitle')}
          </DialogTitle>
          <DialogDescription data-testid="branch-dialog-description">
            {isEditMode
              ? t('branches.dialog.editDescription')
              : t('branches.dialog.createDescription')}
          </DialogDescription>
        </DialogHeader>

        <BranchForm
          branch={branch}
          onSubmit={handleSubmit}
          isLoading={isLoading}
          error={error}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  )
}

